import get from 'get-value';
import moment from 'moment/min/moment-with-locales';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import 'react-table/react-table.css';
import { debounce } from 'throttle-debounce';
import { fetchAseInternalTicketHistoryPageData } from '../../../actions/ase/actionAseInternalTicketHistoryPage';
import { ASE_INTERNAL_MAINTENANCE_TICKET_FORM, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM, ASE_INTERNAL_TICKET_FORM } from '../../../constants/formConstants';
import historyMessages from '../../../intl/afterSales/historyMessages';
import { ASE_INTERNAL_MAINTENANCE_TICKET, ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET, ASE_INTERNAL_TICKET } from '../../../routes/paths';
import { formatInternalTicketNumber } from '../../../utils/utils';
import Table from '../../common/table/TicketTable';

class HistoryAseInternalTicketTable extends Component {
    constructor(props) {
        super(props);
        this.state = this.loadStateFromSessionStorage({
            historyInternalAseDefaultPageSize: 10,
            historyInternalAseDefaultSort: [{id: 'TICKET_NUMBER', desc: true}],
            historyInternalAseDefaultFilters: [],
        });
        this.filtering = false;
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^historyInternalAse*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage = () => {
        for (let key in this.state) {
            if (this.state.hasOwnProperty(key) && key.match(/^historyInternalAse*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchAseInternalTicketHistoryPageData(state.pageSize, state.sorted, state.cursor, state.isNextFromPivot, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            historyInternalAseDefaultPageSize: state.pageSize,
            historyInternalAseDefaultSort: state.sorted,
            historyInternalAseDefaultFilters: state.filtered,
        });
    };

    fetchStrategy = (state) => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date || filterItem.id === 'IT_CREATION_TIME' || filterItem.id === 'LAST_UPDATE') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10),
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, isNextPage, isNextFromPivot} = this.props;

        const formTypeToPathMap = {
            [ASE_INTERNAL_TICKET_FORM]: ASE_INTERNAL_TICKET,
            [ASE_INTERNAL_MAINTENANCE_TICKET_FORM]: ASE_INTERNAL_MAINTENANCE_TICKET,
            [ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM]: ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET,
        };

        return (
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'TICKET_NUMBER',
                                    accessor: 'ticketNumber',
                                    message: historyMessages.TABLE_INTERNAL_TICKET_NUMBER,
                                    Cell: row => {
                                        const path = `${formTypeToPathMap[get(row, 'original.formType') || ASE_INTERNAL_TICKET]}/view/${row.original.id}`;
                                        return <Link to={path}>{get(row, 'original.pfxNumber') ? formatInternalTicketNumber(get(row, 'original.pfxNumber'), get(row, 'original.sfxNumber')) : ''}</Link>
                                    }
                                },
                                ...columns]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={this.state.historyInternalAseDefaultFilters}
                            defaultSorting={this.state.historyInternalAseDefaultSort}
                            defaultPageSize={this.state.historyInternalAseDefaultPageSize}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

HistoryAseInternalTicketTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    isNextPage: PropTypes.bool.isRequired,
    isNextFromPivot: PropTypes.bool.isRequired,
    pages: PropTypes.number.isRequired,
    fetchAseInternalTicketHistoryPageData: PropTypes.func.isRequired,
    columns: PropTypes.array,
};

const mapStateToProps = state => ({
    isLoading: state.aseInternalTicketHistoryPage.isTableLoading,
    data: state.aseInternalTicketHistoryPage.listData,
    isNextPage: state.aseInternalTicketHistoryPage.isNextPage,
    isNextFromPivot: state.aseInternalTicketHistoryPage.isNextFromPivot,
    pages: state.aseInternalTicketHistoryPage.pages,
});

export default connect(mapStateToProps, {fetchAseInternalTicketHistoryPageData})(HistoryAseInternalTicketTable);
